import React, { Component } from 'react'
import { meta } from 'helpers/decorators'
import { apiCommon, apiTranslationsManagement, apiMessages } from 'helpers/decorators/api'
import { MessagesTable } from 'components/sections/messages'
import { FilterMessages } from 'containers/filters'
import SettingMessages from '../../settings/SettingMessages/SettingMessages'

@meta({
    title: 'Message Center',
    intlKey: 'pageTitle.message_center'
})
@apiMessages({
    list: true,
    filter: 'organizationMessages',
    newOnly: true,
})
@apiTranslationsManagement()
@apiCommon({ locales: true })
class OrganizationMessages extends Component {
  render() {
    return (
      <div>
        <FilterMessages />
        <SettingMessages />
        <MessagesTable {...this.props} />
      </div>
    )
  }
}

export default OrganizationMessages
